import React from 'react';
// Toaster removed - using global Toaster from App.js

const FacilityInfoStep = ({
  facilityInfo,
  industries,
  availableSubIndustries,
  emhaQuestionCount,
  onChangeField,
  onOpenGuidanceModal,
  onStartAssessment,
}) => (
  <>
    {/* Toaster removed - using global Toaster from App.js */}

    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-blue-50 dark:from-gray-900 dark:to-gray-800 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
              Energy Management Health Assessment (EMHA) 
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
              Assess your organization&apos;s energy management maturity across 7 key areas
            </p>

            <button
              type="button"
              onClick={onOpenGuidanceModal}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg
               bg-emerald-600 hover:bg-emerald-700 text-white font-medium
               shadow-sm hover:shadow transition-all duration-200
               focus:outline-none focus:ring-2 focus:ring-emerald-400
               focus:ring-offset-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Want Consultant Guidance?
            </button>
          </div>

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Company Name *
              </label>
              <input
                type="text"
                value={facilityInfo.companyName}
                onChange={onChangeField('companyName')}
                className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 dark:focus:ring-emerald-400"
                placeholder="Enter your company name"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Contact Person *
              </label>
              <input
                type="text"
                value={facilityInfo.contactName}
                onChange={onChangeField('contactName')}
                className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 dark:focus:ring-emerald-400"
                placeholder="Enter contact person name"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Email Address *
              </label>
              <input
                type="email"
                value={facilityInfo.email}
                onChange={onChangeField('email')}
                className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 dark:focus:ring-emerald-400"
                placeholder="Enter email address"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Annual Energy Spend (AUD) *
              </label>
              <input
                type="number"
                value={facilityInfo.annualEnergySpend}
                onChange={onChangeField('annualEnergySpend')}
                className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 dark:focus:ring-emerald-400"
                placeholder="Enter annual energy spend"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Major Industry Sector *{' '}
                <span className="text-xs text-gray-500 dark:text-gray-400">
                  (NAICS & ANZSIC)
                </span>
              </label>
              <select
                value={(() => {
                  // Convert industry name back to "id::region" format for select value
                  if (!facilityInfo.majorIndustry) return '';
                  // Use region from facilityInfo to find the correct industry (important for same-name industries in different regions)
                  const currentRegion = (facilityInfo.region || 'naics').toLowerCase();
                  const selectedIndustry = industries.find(ind => {
                    const name = ind.name || '';
                    const indRegion = (ind.region || 'naics').toLowerCase();
                    // Match both name AND region to get the correct industry
                    return name === facilityInfo.majorIndustry && indRegion === currentRegion;
                  });
                  // Fallback: if not found with region, try without region (for backward compatibility)
                  const fallbackIndustry = selectedIndustry || industries.find(ind => {
                    const name = ind.name || '';
                    return name === facilityInfo.majorIndustry;
                  });
                  if (fallbackIndustry) {
                    const region = (fallbackIndustry.region || currentRegion || 'naics').toLowerCase();
                    const industryId = fallbackIndustry.id || '';
                    return industryId ? `${industryId}::${region}` : `${facilityInfo.majorIndustry}::${region}`;
                  }
                  return facilityInfo.majorIndustry;
                })()}
                onChange={onChangeField('majorIndustry')}
                className="w-full px-3 py-2 sm:px-4 sm:py-3 text-sm sm:text-base border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-emerald-500 dark:focus:ring-emerald-400"
                required
              >
                <option value="">Select your major industry sector...</option>
                {industries && industries.length > 0 ? (
                  (() => {
                    // Group industries by region (NAICS and ANZSIC)
                    const naicsIndustries = industries.filter(ind => {
                      const region = (ind.region || '').toLowerCase();
                      return region === 'naics';
                    });
                    const anzsicIndustries = industries.filter(ind => {
                      const region = (ind.region || '').toLowerCase();
                      return region === 'anzsic';
                    });
                    const options = [];
                    
                    // Add NAICS industries
                    if (naicsIndustries.length > 0) {
                      options.push(
                        <optgroup key="naics" label="NAICS (North American Industry Classification System)">
                          {naicsIndustries.map((industry) => {
                            const industryName = industry.name || '';
                            const industryId = industry.id || '';
                            const naicsCode = industry.naics_code || '';
                            const displayName = naicsCode 
                              ? `${industryName} (NAICS: ${naicsCode})` 
                              : `${industryName} (NAICS)`;
                            // Use industryId::region as value to uniquely identify the industry
                            const optionValue = industryId ? `${industryId}::naics` : `${industryName}::naics`;
                            return (
                              <option key={`naics-${industryId || industryName}`} value={optionValue}>
                                {displayName}
                              </option>
                            );
                          })}
                        </optgroup>
                      );
                    }
                    
                    // Add ANZSIC industries
                    if (anzsicIndustries.length > 0) {
                      options.push(
                        <optgroup key="anzsic" label="ANZSIC (Australian and New Zealand Standard Industrial Classification)">
                          {anzsicIndustries.map((industry) => {
                            const industryName = industry.name || '';
                            const industryId = industry.id || '';
                            const anzsicCode = industry.anzsic_code || industry.anszic_code || industry.anszics_code || '';
                            const displayName = anzsicCode 
                              ? `${industryName} (ANZSIC: ${anzsicCode})` 
                              : `${industryName} (ANZSIC)`;
                            // Use industryId::region as value to uniquely identify the industry
                            const optionValue = industryId ? `${industryId}::anzsic` : `${industryName}::anzsic`;
                            return (
                              <option key={`anzsic-${industryId || industryName}`} value={optionValue}>
                                {displayName}
                              </option>
                            );
                          })}
                        </optgroup>
                      );
                    }
                    
                    // If no grouping worked, fallback to original display
                    if (options.length === 0) {
                      return industries.map((industry) => {
                        const industryName = industry.name || '';
                        const region = industry.region || '';
                        const displayName = region ? `${industryName} (${region.toUpperCase()})` : industryName;
                        return (
                          <option key={industry.id || industryName} value={industryName}>
                            {displayName}
                          </option>
                        );
                      });
                    }
                    
                    return options;
                  })()
                ) : (
                  <option value="" disabled>Loading industries...</option>
                )}
              </select>
              {industries && industries.length === 0 && (
                <p className="mt-1 text-xs text-red-600 dark:text-red-400">
                  No industries available. Please check your connection or try refreshing the page.
                </p>
              )}
            </div>

            {facilityInfo.majorIndustry && availableSubIndustries.length > 0 && (
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Sub-Industry *
                </label>
                <select
                  value={facilityInfo.subIndustry}
                  onChange={onChangeField('subIndustry')}
                  className="w-full px-3 py-2 sm:px-4 sm:py-3 text-sm sm:text-base border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-emerald-500 dark:focus:ring-emerald-400"
                  required
                >
                  <option value="">Select your sub-industry...</option>
                  {availableSubIndustries.map((subIndustry) => {
                    // Handle both string format (legacy) and object format (new schema)
                    const subIndustryName = typeof subIndustry === 'string' 
                      ? subIndustry 
                      : (subIndustry.sub_industry || subIndustry.name || '');
                    const subIndustryKey = typeof subIndustry === 'string'
                      ? subIndustry
                      : (subIndustry.id || subIndustryName);
                    return (
                      <option key={subIndustryKey} value={subIndustryName}>
                        {subIndustryName}
                      </option>
                    );
                  })}
                </select>
              </div>
            )}

            <div className="bg-blue-50 dark:bg-blue-900/30 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
              <h3 className="font-semibold text-blue-800 dark:text-blue-200 mb-2">
                What You&apos;ll Get:
              </h3>
              <ul className="text-sm text-blue-700 dark:text-blue-300 space-y-1">
                <li>✅ Overall Energy Management Maturity Score</li>
                <li>✅ Radar Chart showing strengths across 7 key areas</li>
                <li>✅ Your current LEAP Phase classification</li>
                <li>✅ Basic improvement recommendations</li>
                <li>
                  💎 Upgrade to Full Report ($2,000): Detailed benchmarking &amp; implementation
                  roadmap
                </li>
              </ul>
            </div>

            <div className="flex justify-center">
              <button
                type="button"
                onClick={onStartAssessment}
                disabled={
                  !facilityInfo.companyName ||
                  !facilityInfo.contactName ||
                  !facilityInfo.email ||
                  !facilityInfo.annualEnergySpend ||
                  !facilityInfo.majorIndustry ||
                  !facilityInfo.subIndustry
                }
                className="px-8 py-3 bg-emerald-600 dark:bg-emerald-500 text-white rounded-lg hover:bg-emerald-700 dark:hover:bg-emerald-600 disabled:bg-gray-300 dark:disabled:bg-gray-600 disabled:cursor-not-allowed font-semibold transition-colors"
              >
                Start Assessment ({emhaQuestionCount} Questions)
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default FacilityInfoStep;


